var r = /* @__PURE__ */ ((t) => (t.BUTTON = "button", t.SUBMIT = "submit", t.RESET = "reset", t))(r || {});
export {
  r as BUTTON_TYPE
};
//# sourceMappingURL=button-type.js.map
